const convertCentToUSDWithSymbol = (number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(number);
};

const formatUSDForLimitsProperties = (limits) => {
  const { dailyLimit, checkDepositLimit, monthlyLimit } = limits;
  return {
    dailyLimit: convertCentToUSDWithSymbol(dailyLimit / 100),
    checkDepositLimit: convertCentToUSDWithSymbol(checkDepositLimit / 100),
    monthlyLimit: convertCentToUSDWithSymbol(monthlyLimit / 100)
  };
};

export const validateLimits = ({ value, remainLimits, constants, skipLimitValidate = false }) => {
  const { dailyRemainLimit, monthlyRemainLimit } = remainLimits;
  const { dailyLimit, monthlyLimit } = formatUSDForLimitsProperties(constants);

  switch (true) {
    case typeof value !== 'number' || Number.isNaN(value):
      return {
        value: 0,
        isValid: false,
        isError: true,
        message: 'This deposit amount is not recognized. Please enter digits only.'
      };
    case value === 0 || !dailyRemainLimit || !monthlyRemainLimit:
      return {
        value,
        isValid: false,
        isError: false,
        message: null
      };
    case value > dailyRemainLimit && !skipLimitValidate:
      return {
        value,
        isValid: false,
        isError: true,
        message: `This exceeds the ${dailyLimit} daily check deposit limit.`
      };
    case value > monthlyRemainLimit && !skipLimitValidate:
      return {
        value,
        isValid: false,
        isError: true,
        message: `This exceeds the ${monthlyLimit} monthly check deposit limit.`
      };
    default:
      return {
        value,
        isValid: true,
        isError: false,
        message: null
      };
  }
};

export const validateInvalidValues = ({ state, invalidValues }) => {
  const { value, message } = state;

  if (message) {
    return state;
  }

  for (let i = 0; i < invalidValues.length; i += 1) {
    const invalidValue = invalidValues[i];
    if (value === invalidValue.value) {
      return {
        value,
        isValid: false,
        isError: true,
        message: invalidValue.message
      };
    }
  }

  return state;
};
